module.exports = __webpack_public_path__ + "media/images/icons/sun-d16cd01397226ddbdd3c726cfde2b4f6.svg";